/**
 * Publik shop-meny (toppnav, mobilmeny, startsidans kategorikort).
 *
 * label – text i UI
 * slug  – Core-kategorislug (används i /kategorier/:slug och API)
 * icon  – valfritt: swim | bike | run (övriga utan ikon)
 *
 * tools – fasta länkar som inte är Core-kategorier.
 *
 * Byt slug här när en kategori byter namn i Core (t.ex. Simning → vatdrakt).
 */

module.exports = {
  categories: [
    { label: "Energi", slug: "energi" },
    { label: "Simning", slug: "vatdrakt", icon: "swim" },
    { label: "Cykling", slug: "cykling", icon: "bike" },
    { label: "Löpning", slug: "lopning", icon: "run" },
    { label: "Triathlon", slug: "triathlon" },
    { label: "Elektronik", slug: "elektronik" },
    { label: "Kläder", slug: "klader" },
  ],

  tools: [
    {
      label: "Energikalkylator",
      path: "/energi-kalkylator",
      icon: "calculator",
    },
    {
      label: "Intervallkalkylator",
      path: "/intervall-kalkylator",
      icon: "calculator",
    },
    { label: "Energipaket", path: "/paket", icon: "package" },
  ],
};
